// src/pages/DebtStudio/context/PortfolioSessionContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import useCurrentOwner from "components/FileManager/hooks/useCurrentOwner";
import { useProfile } from "context/ProfileContext";

const PortfolioSessionContext = createContext(null);

export function PortfolioSessionProvider({ children }) {
  const { selectedOrg } = useProfile();
  // Keep this narrowly scoped to “session” state you want to preserve.
  const [portfolioId, setPortfolioId] = useState(null);
  const [activeTab, setActiveTab] = useState("main"); // or whatever your default is
  const [viewState, setViewState] = useState({}); // filters, group mode, chart toggles, etc.
  const currentOwner = useCurrentOwner(viewState?.portfolio?.created_by);

  useEffect(() => {
    setPortfolioId(null);
    setActiveTab("main");
    setViewState({});
  }, [selectedOrg?.id]);

  const value = useMemo(
    () => ({
      portfolioId,
      setPortfolioId,
      activeTab,
      setActiveTab,
      viewState,
      setViewState,
      currentOwner,
      resetPortfolioSession: () => {
        setPortfolioId(null);
        setActiveTab("main");
        setViewState({});
      },
    }),
    [portfolioId, activeTab, viewState, currentOwner]
  );

  return (
    <PortfolioSessionContext.Provider value={value}>
      {children}
    </PortfolioSessionContext.Provider>
  );
}

export function usePortfolioSession() {
  const ctx = useContext(PortfolioSessionContext);
  if (!ctx) {
    throw new Error(
      "usePortfolioSession must be used within PortfolioSessionProvider"
    );
  }
  return ctx;
}
